import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

import { isCostPaused, subscribeCostPaused } from '../features/translate/queue';

/**
 * 전역 번역 일시정지 배너 (PLAN 변경 6장 가드레일 2번).
 *
 * 서버가 일일 상한 초과로 번역을 멈추면 모든 화면이 조용히 원문으로 대체된다.
 * 사용자가 알 수 없으면 "설정이 안 먹혔다"고 오해하므로, 원인을 한 줄로 밝힌다.
 * 닫을 수 있게 하지 않는다 — 해결은 어드민 콘솔에서만 가능하고, 닫아도
 * 번역은 계속 멈춰 있기 때문이다.
 */
export function TranslationPausedBanner() {
  const { t } = useTranslation();
  const paused = useSyncExternalStore(subscribeCostPaused, isCostPaused, () => false);

  if (!paused) return null;

  return (
    <p
      role="status"
      className="bg-[var(--danger)]/15 px-4 py-1.5 text-center text-xs text-[var(--danger)]"
    >
      {t('translate.costPaused')}
    </p>
  );
}
